module.exports = __webpack_public_path__ + "media/images/athletes/2586-c9ee6d4e5535c6fc20b0049f9096931d.png";